import SectionCompetitiveAdvantages from '@/components/pages/Home/SectionCompetitiveAdvantages';
import SectionCoreValueProposition from '@/components/pages/Home/SectionCoreValueProposition';
import SectionHeader from '@/components/pages/Home/SectionHeader';
import SectionKeyServiceHighlight from '@/components/pages/Home/SectionKeyServiceHighlight';
import SectionOurCustomer from '@/components/pages/Home/SectionOurCustomer';
import SectionResultWeDeliver from '@/components/pages/Home/SectionResultWeDeliver';
import SectionSolution from '@/components/pages/Home/SectionSolution';
const Home = () => {
  return (
    <main>
      <SectionHeader />
      <SectionCoreValueProposition />
      <SectionOurCustomer />
      <SectionKeyServiceHighlight />
      <SectionSolution />
      <SectionCompetitiveAdvantages />
      <SectionResultWeDeliver />
    </main>
  );
};

export default Home;
